import { render, staticRenderFns } from "./EmailReviewersAction.vue?vue&type=template&id=bafc09b2"
import script from "./EmailReviewersAction.vue?vue&type=script&lang=js"
export * from "./EmailReviewersAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports